import { createContext, useEffect, useRef, useState } from "react";
import io from "socket.io-client";

export const SocketContext = createContext(null);

export function SocketProvider({ children }) {
	const socketRef = useRef(null);
	const [socket, setSocket] = useState(null);

	useEffect(() => {
		if (socketRef.current) return; // ✅ StrictMode 2회 실행 방어

		const s = io(process.env.REACT_APP_SOCKET_URL, {
			path: "/socket.io",
			transports: ["polling", "websocket"], // ✅ fallback 허용
			autoConnect: true,
			reconnection: true,
			reconnectionAttempts: 10,
			reconnectionDelay: 500,
			reconnectionDelayMax: 3000,
			timeout: 20000,
		});

		s.on("connect", () => console.log("✅ connect", s.id));
		s.on("disconnect", (r) => console.log("❌ disconnect", r));
		s.io.on("reconnect_attempt", (n) => console.log("🔄 reconnect_attempt", n));
		s.io.on("reconnect_error", (e) => console.log("⚠️ reconnect_error", e.message));
		s.on("connect_error", (e) => {
			console.log(e);

			console.log("⚠️ connect_error", e.message);
		});

		socketRef.current = s;
		setSocket(s);

		return () => {
			// ✅ 개발 StrictMode에서는 cleanup이 한번 더 불릴 수 있어서
			// 실제 운영에서 Provider가 언마운트될 때만 끊는게 좋음.
			// 일단은 끊되, ref 정리까지 같이.
			s.disconnect();
			socketRef.current = null;
		};
	}, []);

	return <SocketContext.Provider value={{ socket }}>{children}</SocketContext.Provider>;
}
